import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Database } from '../../providers/database';
import { EventData } from '../../providers/event';
import { AuthData } from '../../providers/auth';
import { Payment } from './payment/payment';

@Component({
  selector: 'page-event-catalogs-payment',
  templateUrl: 'event-catalogs-payment.html',
})
export class EventCatalogsPayment {

  client: any;
  event: any;
  dataPayments: any;

  constructor(public navCtrl: NavController, public params: NavParams, public db: Database, public eventProvider: EventData, public auth: AuthData) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');

    this.eventProvider.getPayments(this.client, this.auth.getUser().uid).subscribe((result) => {
      console.log(result)
      this.dataPayments = result;
    });
  }

  viewPay(pay) {
    this.navCtrl.push(Payment, {client: this.client, event: this.event, dataPay: pay});
  }

}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-catalogs-payment/event-catalogs-payment.ts